import React, { useState, useEffect, useCallback } from 'react';

export default function Timer({ seconds, onFinish }) {

  const [lastUntil, setLastUntil] = useState(null);
  const [until, setUntil] = useState(Math.max(seconds, 0));
  
  const updateTimer = useCallback(() => {
    if (lastUntil === until) {
      return;
    }
    if (until === 1 || (until === 0 && lastUntil !== 1)) {
      if (onFinish) {
        setTimeout(()=> {
          onFinish();
        })
      }
    }
    if (until === 0) {
      setLastUntil(0);
      setUntil(0);
    } else {
      setLastUntil(until);
      setUntil(prevState => (
          Math.max(0, prevState - 1)
      ));
    }
  }, [lastUntil, onFinish, until]);

  useEffect(() => {
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, [updateTimer]);
  
  const getTimeLeft = () => {
    return {
      seconds: until % 60,
      minutes: parseInt(until / 60, 10) % 60,
    };
  };
  
  return (
      <div className='d-flex' style={{justifyContent:'center'}}>
        <span > :{getTimeLeft().minutes}</span>
        <span >{('0' + getTimeLeft().seconds).slice(-2)}</span>
      </div>
  );
}
